import { z } from 'zod';

export const analyticsSchema = z.object({
    analytics_fb_pixel_token: z.string().optional(),
    analytics_google_token: z.string().optional(),
    analytics_tiktok_pixel_token: z.string().optional(),
    pinterest_tag_id: z.string().optional(),
});

export type AnalyticsFormData = z.infer<typeof analyticsSchema>;
